// extracted by mini-css-extract-plugin
export default {"wix-offering-style":"_1vkbyel","wixOfferingStyle":"_1vkbyel"};